import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icon from '../Icon';
import CommitStatus from './CommitStatus';
import { Trans } from 'react-i18next';
export default class CommitStatusFailed extends CommitStatus {
    // @TODO should be resolved without underscore - better design to not have it here 
    renderStatusBadge(_commitOptions, _errorCount, _warningCount, _isCommitDone, _isCommitTimedOut, _isCommitMeetingThreshold, _loading) {
        return _jsxs("small", { className: "text-danger", children: [_jsx(Icon, { name: "exclamation" }), " ", _jsx(Trans, { i18nKey: "failure", children: "failure" })] });
    }
}
